import Head from 'next/head';
import { useRouter } from 'next/router';
import { useState } from 'react';

import 'styles/Home.module.css';

import Metatag from 'app/components/metaTag';
import { NEW_CONTACT_US } from 'app/helpers/apiEndpoint';
import REQUEST from 'app/helpers/http.service';
import AnyQuery from 'app/components/common/AnyQuery';
import HeroForContact from 'app/components/common/HeroForContact';
import './contact-form.css';
import WriteCTA from 'app/components/writetous/WriteCTA';
import HireScheduleTalent from 'app/components/common/HireScheduleTalent';

export default function ContactUs({ contactUsData }) {
  const { asPath } = useRouter();
  const router = useRouter();
  const [modalScheduleCall, setModalScheduleCall] = useState(false);

  const canonicalUrl = (
    `${process.env.NEXT_PUBLIC_BASE_URL}` +
    (router.asPath === '/' ? '' : router.asPath)
  ).split('?')[0];

  return (
    <div className="md:pt-[80px] pt-[70px] roboto bg-[#000815]">
      <Head>
        <title>{contactUsData?.title ? contactUsData?.title : `VLink`}</title>
        <meta
          name="description"
          content={contactUsData?.description || 'Vlink Description'}
        />
        <meta
          property="og:title"
          content={contactUsData?.title ? contactUsData?.title : `Vlink`}
        />
        <meta
          property="og:description"
          content={contactUsData?.description || 'Vlink Description'}
        />
        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_BASE_URL}${asPath}`}
        />

        <Metatag content={`https://www.vlinkinfo.com/img/logopng.png`} />

        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <HeroForContact
        data={contactUsData?.HeroSection}
        clientlogo={contactUsData?.Trusted500}
        setModalCall={setModalScheduleCall}
      />
      <section className="xl:my-[75px] my-[45px]">
        <AnyQuery data={contactUsData?.Reasons} />
      </section>
      {/* <section className="xl:py-[75px] py-[45px]">
        <PricingCTA data={contactUsData?.Updates} isContect={true} />
      </section> */}
      {contactUsData?.Updates && (
        <WriteCTA
          Pricing={contactUsData?.Updates}
          setModalCall={setModalScheduleCall}
          isContect={true}
        />
      )}
      {modalScheduleCall && (
        <HireScheduleTalent
          ButtonText={modalScheduleCall}
          setIsOpen={setModalScheduleCall}
        />
      )}
    </div>
  );
}

export async function getStaticProps() {
  const [contactUsData] = await Promise.all([
    REQUEST({
      method: 'GET',
      url: NEW_CONTACT_US,
    }),
  ]);
  return {
    props: { contactUsData: contactUsData?.data?.data?.attributes },
  };
}
